import { useIntl } from 'react-intl'
import { MaybeString } from '../../utils'

export const useTextOrTranslation = (
  text: MaybeString,
  translationId: MaybeString
) => {
  const { formatMessage } = useIntl()

  return (
    text ||
    (translationId
      ? formatMessage({
          id: translationId
        })
      : '')
  )
}
